import resolve from "ioc/resolve";
import $session from "servicestack/session";
export const IS_CMS = (ENV_TAGS || []).indexOf("Cms") >= 0;

export const EMPTY_PIXEL =
  "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";

const last365 = () => moment().subtract(1, "year").format("YYYY-MM-DD");

const shoppingConfig = {
  zoomApiKey: "RzUljZaTTaqK0H5VcXtsDQ",
  runOnStartUp() {
    //console.debug("runOnStartUp", shoppingConfig);
  },
  tagTotalsUrl: `QueryProductTagTotals.json?CachePrefix=Wholesale&CacheDuration=24:00:00&op=ProductQuery&ProductIdsToTake=0&JsConfig=ExcludeDefaultValues`,
  fields:
    "Id,ManufacturerNumber,ShortDescription,LongDescription,Status,Pricing,ListPrice,WholesalePrice,RetailPrice,RetailListPrice,Price,MinimumOrderQty,Areas,AvailableQty,IncomingQty,PurchaseIncrement,VendorId,ItemType,isKitEditable,Meta,CreatedOn,ShipOn,AvailableOn,OptionGroup,Dimensions",
  navs: [],
  filters: [
    { text: "Referrer", hidden: true },
    { text: "Search", operation: "" }, //StarsWith|EndsWith|Contains|EqualTo
    { text: "ListId", operation: "", hidden: true }, //StarsWith|EndsWith|Contains|EqualTo
    { text: "MutEx", operation: "", hidden: true }, //StarsWith|EndsWith|Contains|EqualTo
    {
      radio: "ListId",
      title: "Corporate Lists",
      collapsed: true,
      authorize: (s) => s.isAuthenticated,
      $onInit(g) {
        g.bus
          .send(
            "QueryProductLists.json?expired=false&VisibilityList=ShopFilters"
          )
          .then((res) => {
            g.options = res.data.results
              .filter((list) =>
                list.visibility.some((v) => v === "ShopFilters")
              )
              .map((list) => ({
                fieldName: g.radio,
                label: list.label,
                description: list.description,
                isSelected: (g) => g.query.criteria[g.radio] === list.id,
                toggle: (g) => {
                  if (g.query.criteria[g.radio] !== list.id) {
                    g.query.criteria[g.radio] = list.id;
                    g.query.sort("Position");
                  } else {
                    delete g.query.criteria[g.radio];
                  }
                },
                value: () => list.id,
              }));
          });
      },
    },
    {
      radio: "ListId",
      title: "Your Lists",
      collapsed: true,
      authorize: (s) => s.isAuthenticated && s.isRepOrManager(),
      $onInit(g) {
        g.bus
          .send(
            "QueryProductLists.json?expired=false&VisibilityList=OrderEntry"
          )
          .then((res) => {
            g.options = res.data.results
              .filter((list) => list.visibility.some((v) => v === "OrderEntry"))
              .map((list) => ({
                fieldName: g.radio,
                label: list.label,
                description: list.description,
                isSelected: (g) => g.query.criteria[g.radio] === list.id,
                toggle: (g) => {
                  if (g.query.criteria[g.radio] !== list.id) {
                    g.query.criteria[g.radio] = list.id;
                    g.query.sort("Position");
                  } else {
                    delete g.query.criteria[g.radio];
                  }
                },
                value: () => list.id,
              }));
          });
      },
    },
    {
      radio: "MutEx",
      title: "Order History",
      collapsed: true,
      authorize: (s) => s.isAuthenticated,
      options: [
        {
          fieldName: "PurchasedAfter",
          label: "Purchased last 365",
          value: last365,
        },
        {
          fieldName: "ShippedAfter",
          label: "Shipped last 365",
          value: last365,
        },
        {
          fieldName: "OnOpenOrders",
          label: "On Open Orders",
          value: last365,
        },
        {
          fieldName: "TopSellersBySource",
          label: "Top 50 Show Sellers",
          value: () =>
            `Show:${moment().subtract(6, "month").format("YYYY-MM-DD")}:50`,
        },
        {
          fieldName: "OnOrder",
          label: "On Current Order",
          value: () => resolve("$cart").id,
        },
      ],
    },
    { text: "PriceListId", operation: "", hidden: true }, //StarsWith|EndsWith|Contains|EqualTo
    { tag: "Brand" },
    { tag: "Collection" },
    { tag: "Category" },
    { tag: "Sub Category" },
    {
      groupBy: "IsNew",
      title: "New Introduction",
      formatter: (tag) => (tag.tagLabel ? "Yes" : "No"),
    },
    { date: "CreatedOn", title: "Created Date" },
    {
      number: "WholesalePrice",
      title: "Price",
      min: 0,
      max: 2000,
      step: 0.01,
      authorize: (s) => s.isAuthenticated || s.businessModel === "Retail",
    },
    {
      text: "utm_source",
      operation: "",
      hidden: true,
      authorize: (s) => IS_CMS,
    },
    {
      text: "utm_medium",
      operation: "",
      hidden: true,
      authorize: (s) => IS_CMS,
    },
    {
      text: "utm_campaign",
      operation: "",
      hidden: true,
      authorize: (s) => IS_CMS,
    },
    {
      text: "spMailingID",
      operation: "",
      hidden: true,
      authorize: (s) => IS_CMS,
    },
    { text: "spUserID", operation: "", hidden: true, authorize: (s) => IS_CMS },
    { text: "spJobID", operation: "", hidden: true, authorize: (s) => IS_CMS },
    {
      text: "spReportId",
      operation: "",
      hidden: true,
      authorize: (s) => IS_CMS,
    },
  ],
  forceViewCartOnCheckout: false,
  showQtyAndAdd: false,
  showNavPanel: false,
  scrollTop: true,
  maxNavHeight: "",
  navTitle: "",
  messages: {
    noProducts: "Your search criteria has resulted in no products",
  },
  hideLeftNav: () => true, //$pageConfig.is('lt-md'),
  generateCartName: () =>
    "My Cart" +
    ($session.businessModel === "Wholesale"
      ? " - " + resolve("$filter")("date")(new Date(), "M/d/yyyy")
      : ""),
  queryProductsContext: "shop",
  hideProductLikes: false,
  hideEmptyGroupings: false,
  hideAddToList: false,
  hideGroupingCounts: false,
  hidePriceFilter: false,
  shoppingSearchTop: true,
  maxPanelHeight: "300px",
  panelType: "default",
  orderBy: "MainFeatured,Featured,Id",
  showGiftCard: false,
  requireCVV: false,
  hideNavContinueShopping: true,
  hideShippingMethods: false,
  hideShippingRates: false,
  views: {
    list: "th-list",
    cards: "th",
    masonry: "th-large",
  },
  hideProductReviews: true,
  productImagesPriority: false, // demdaco desinations
  relatedItemsTagKind: "Category",
  othersBoughtTagKind: "Sub-Category",
  notifyItemOnOpenOrder: true,
  sortOptions: {
    Id: "Sku: Low to High",
    "MainFeatured,Featured,Id": "Featured",
    "ShortDescription,Id": "Description: A to Z",
    "-CreatedOn,Id": "Date Created: Oldest",
    "RetailPrice,Id": "Price - Low to High",
    "-RetailPrice,Id": "Price - High to Low",
  },
  defaultSortLabel: "Featured",
  queryProductsCriteria: {},
  // fields
  lblCustomize: "Customize",
  lblAdd: "Add",
  requireAcceptTerms: false,
  requireAcceptTermsMessage:
    "You must agree to terms of service before submitting order",
  showAcceptTerms: false,
  useGAECommerce: false,
  useFaceBookPixel: false,
  refundReasons: ["", "Product didn't fit", "Poor quality", "Other"],
  storeFinderDefaultRadius: 25,
  storeFinderHideProduct: false,
  resetOneUpAfterAddingConfigurable: false,
  useMultiAddPopup: true,
  showSearchCountry: false,
  showKitComponents: false,
  personalizationDelimiter: "/|\\",
  //pixels
  oneUpPixels: ($session, $cart, product) => [EMPTY_PIXEL],
  cartPixels: ($session, $cart) => [EMPTY_PIXEL],
  checkoutPixels: ($session, $cart) => [EMPTY_PIXEL],
  getShoppingParams(config) {
    let shopParams = {};
    (config || shoppingConfig).filters.forEach((f) => {
      ["tag", "groupBy", "number", "text", "date"].forEach((t) => {
        if (f[t]) shopParams[f[t]] = null;
      });
    });
    return shopParams;
  },
  getProductLd(product) {
    return {
      "@context": "http://schema.org/",
      "@type": "Product",
      name: product.shortDescription,
      image: product.getImageUrl("medium"),
      description: product.longDescription,
      sku: product.id,
      mpn: product.upcCode || product.id,
      brand: product.categoryId || product.vendorId,
      offers: {
        "@type": "Offer",
        priceCurrency: "USD",
        price: product.price || product.retailPrice,
        itemCondition: "http://schema.org/New",
        availability: "http://schema.org/InStock",
      },
    };
  },
  showTearsheetOnMultiView: false,
  showOptionsOnMultiView: false,
  optionsTagKind: "Sizes",
  useQuickView: false,
  shopRouteTemplateProvider: ($stateParams, $location) =>
    `<shopping-container context="${
      Object.assign({}, $location.search(), $stateParams).context || ""
    }" use-quick-view="${shoppingConfig.useQuickView}"/>`,
  multiviewUrl: `/?designId&tagCriteria&Brand&Search`,
  selfCheckout: false,
  multiCart: false,
  disableAccessoryProducts: true,
};

export default shoppingConfig;
